import gql from 'graphql-tag';

export default gql`
    query GetStagesByJobId($jobId: Int, $proppantId: Int) {
        getStagesByJobId(jobId: $jobId, proppantId: $proppantId) {
            jobStageId
            stage
            status
            wellhead
            overallStage
        }
    }
`;
